/**
 * SIMPLIFIED Add to Cart Functions
 * No universal tracking - just basic Shopify add to cart functionality
 */

/**
 * Simple add item to cart function
 * @param {string} variantId - The variant ID to add to cart
 * @param {number} quantity - The quantity to add (default: 1)
 * @param {HTMLElement} button - The button element that triggered the action
 * @returns {Promise} - Promise that resolves when the item is added to cart
 */
function addToCart(variantId, quantity = 1, button = null) {
  if (!variantId) {
    console.error('No variant ID provided');
    return Promise.reject('No variant ID provided');
  }

  // Convert and validate inputs
  const parsedVariantId = parseInt(variantId);
  const parsedQuantity = parseInt(quantity);
  
  if (isNaN(parsedVariantId) || parsedVariantId <= 0) {
    console.error('Invalid variant ID:', variantId);
    return Promise.reject('Invalid variant ID');
  }
  
  if (isNaN(parsedQuantity) || parsedQuantity <= 0) {
    console.error('Invalid quantity:', quantity);
    return Promise.reject('Invalid quantity');
  }

  console.log('Adding to cart - Variant ID:', parsedVariantId, 'Quantity:', parsedQuantity);

  // Store original content outside the promise chain
  let originalContent = '';
  
  // Show loading state if button is provided
  if (button) {
    originalContent = button.innerHTML;
    button.innerHTML = 'Adding...';
    button.style.opacity = '0.7';
    button.disabled = true;
  }

  const formData = {
    'items': [{
      'id': parsedVariantId,
      'quantity': parsedQuantity
    }]
  };
  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })  .then(data => {
    // SHOPIFY PIXEL MANAGER COMPLIANT TRACKING
    if (data.items && data.items.length > 0) {
      const addedItem = data.items[0];
      
      // 1. Fire Shopify cart change event for Pixel Manager (REQUIRED)
      try {
        document.dispatchEvent(new CustomEvent('shopify:cart:change'));
        console.log('✅ Shopify Pixel Manager: cart:change event fired');
      } catch (error) {
        console.error('❌ Shopify Pixel Manager cart:change error:', error);
      }
      
      // 2. Optional: Shopify Customer Events API for additional tracking
      if (window.Shopify?.customerEvents?.publish) {
        try {
          window.Shopify.customerEvents.publish('cart_line_added', {
            productVariantId: addedItem.variant_id,
            quantity: addedItem.quantity
          });
          console.log('✅ Shopify Customer Events: cart_line_added event published');
        } catch (error) {
          console.error('❌ Shopify Customer Events error:', error);
        }
      }
    }
    
    // Update cart count in header
    const headerCartCount = document.getElementById('headerCartCount');
    if (headerCartCount) {
      headerCartCount.textContent = data.item_count;
    }

    // Show success message
    if (button) {
      button.innerHTML = 'Added!';
      button.style.backgroundColor = '#00C851';
      button.style.opacity = '1';
      button.disabled = false;
      
      // Open cart drawer if functions exist
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      }
      if (typeof window.refreshCartDrawer === 'function') {
        window.refreshCartDrawer();
      }
      
      // Reset button after delay
      setTimeout(() => {
        button.innerHTML = originalContent;
        button.style.backgroundColor = '';
      }, 2000);
    }
    
    return data;
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    
    if (button) {
      button.innerHTML = 'Error';
      button.style.backgroundColor = '#ff4444';
      button.style.opacity = '1';
      button.disabled = false;
      
      // Reset button after delay
      setTimeout(() => {
        button.innerHTML = originalContent;
        button.style.backgroundColor = '';
      }, 2000);
    }
    
    throw error;
  });
}

// NOTE: cart drawer open/close/refresh, quantity updates and item removal are
// owned entirely by sections/cart-drawer.liquid's inline script. This file used
// to redefine the same window.* function names with an older "queue/transfer"
// themed implementation (different classes, different copy) that loaded after
// cart-drawer.liquid's script and silently clobbered it on every page — that's
// why the drawer looked broken and unstyled. Only addToCart lives here now,
// since assets/product-modal.js's quick-view still calls window.addToCart.
window.addToCart = addToCart;
window.cartFunctions = { addToCart: addToCart };

console.log('Simple cart functions loaded');
